import * as React from 'react';
import { MediaQuery, Modal, Button, RichTextArea } from '@grandvisionhq/common';
import { Hr, Heading } from '@grandvisionhq/elements';

const DeliveryIndicatorModal = ({ deliveryInfo , isModalOpen , onModalClose  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { items =[] , description: description1 , link , linkHint , title: title1  } = deliveryInfo;
    return /*#__PURE__*/ React.createElement(Modal, {
        className: "delivery-modal",
        isOpen: isModalOpen,
        onModalClose: onModalClose,
        showIcon: true,
        title: title1,
        footer: link && /*#__PURE__*/ React.createElement(React.Fragment, null, linkHint && /*#__PURE__*/ React.createElement("p", null, linkHint), /*#__PURE__*/ React.createElement(Button, {
            caption: link.label,
            href: link.url,
            hrefTarget: link.target === 'external' ? '_blank' : undefined,
            size: "large"
        }))
    }, /*#__PURE__*/ React.createElement("div", {
        className: "delivery-modal__container"
    }, description1 && /*#__PURE__*/ React.createElement(RichTextArea, {
        className: "delivery-modal__description",
        content: description1
    }), items.map(({ description , id , image , price , title  })=>/*#__PURE__*/ React.createElement("div", {
            key: id,
            className: "delivery-modal-item"
        }, /*#__PURE__*/ React.createElement(Hr, {
            className: "delivery-modal-item__horizontal-rule"
        }), /*#__PURE__*/ React.createElement("div", {
            className: "delivery-modal-item__header"
        }, title && /*#__PURE__*/ React.createElement(Heading, {
            component: "h2",
            variant: "smallest"
        }, title), price && /*#__PURE__*/ React.createElement(Heading, {
            component: "h3",
            variant: "smallest"
        }, "\xa0\xb7 ", price)), /*#__PURE__*/ React.createElement("div", {
            className: "delivery-modal-item__content"
        }, image && /*#__PURE__*/ React.createElement("div", {
            className: "delivery-modal-item__image-container"
        }, /*#__PURE__*/ React.createElement("img", {
            className: "delivery-modal-item__image",
            src: isSmallScreen ? image.mobile.url : image.original.url,
            alt: image.alt,
            width: isSmallScreen ? image.mobile.dimensions.w : image.original.dimensions.w,
            height: isSmallScreen ? image.mobile.dimensions.h : image.original.dimensions.h
        })), description && /*#__PURE__*/ React.createElement(RichTextArea, {
            className: "delivery-modal-item__description",
            content: description
        })))
    )));
};
var DeliveryIndicatorModal$1 = DeliveryIndicatorModal;

export { DeliveryIndicatorModal, DeliveryIndicatorModal$1 as default };
//# sourceMappingURL=DeliveryIndicatorModal.js.map
